import { getAIProvider, resolveAIProviderId } from "../../shared/aiProviders";
import type { AiProvider as AiConfig } from "../../shared/generatedDrizzleSchema";

export function getConfigProvider(
  config: Pick<AiConfig, "provider" | "baseUrl">
) {
  return resolveAIProviderId(config);
}

export function getConfigSubtitle(
  config: Pick<AiConfig, "provider" | "baseUrl" | "createdAt">
) {
  const definition = getAIProvider(getConfigProvider(config));
  if (definition.subtitleField) {
    const credentials = definition.unpackCredentials({
      baseUrl: config.baseUrl ?? "",
      apiKey: "",
    });
    const value = credentials[definition.subtitleField];
    if (value) return value;
  }
  return `Added ${new Date(config.createdAt).toLocaleDateString()}`;
}
